class HomeReviews extends HTMLElement {
  constructor() {
    super();

    this.reviews_button_expand = this.querySelectorAll(
      ".product-review__see-more"
    );
    this.reviews_button_crop = this.querySelectorAll(
      ".product-review__see-less"
    );

    this.reviews_button_expand.forEach((review) => {
      review.addEventListener("click", this.expandReview.bind(this));
    });

    this.reviews_button_crop.forEach((review) => {
      review.addEventListener("click", this.cropReview.bind(this));
    });
  }

  expandReview(e) {
    e.currentTarget
      .closest(".product-review-item")
      .classList.add("product-review-item--expanded");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review-item__content--crop")
      .classList.add("hidden");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review-item__content--full")
      .classList.remove("hidden");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review__see-more")
      .classList.add("hidden");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review__see-less")
      .classList.remove("hidden");
  }

  cropReview(e) {
    e.currentTarget
      .closest(".product-review-item")
      .classList.remove("product-review-item--expanded");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review-item__content--crop")
      .classList.remove("hidden");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review-item__content--full")
      .classList.add("hidden");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review__see-less")
      .classList.add("hidden");
    e.currentTarget
      .closest(".product-review-item")
      .querySelector(".product-review__see-more")
      .classList.remove("hidden");
  }
}

customElements.define("home-reviews", HomeReviews);
